import React from "react";
import ReactDOM from "react-dom";

import { closeIcon } from "./SVG";
import { motion } from "framer-motion";
export default function Modal({
  close,
  children,
  addClass,
  title,
  showCloseIcon = true,
}) {
  const closeOnFog = (e) => {
    if (e.target === e.currentTarget) close();
  };

  return ReactDOM.createPortal(
    <div className="modal" onClick={closeOnFog}>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2 }}
        exit={{ opacity: 0, y: 30 }}
        className={"modal__inner " + (addClass ? addClass : "")}
      >
          {showCloseIcon && (
        <div className="modal__inner-header">
          <h5>{title}</h5>
            <div className="modal__inner-close" onClick={close}>
              {closeIcon}
            </div>
          
        </div>
)}
        {children}
      </motion.div>
    </div>,
    document.getElementById("modals")
  );
}
